import { renderMagazineSwiper } from 'js/magazin/initMagazineSwiper'

const pushBreakpoints = (slidesPerView) => ({
  600: {
    slidesPerView: slidesPerView.tablet,
    slidesPerGroup: 1,
    spaceBetween: 30,
  },
  768: {
    slidesPerView: slidesPerView.tablet,
    slidesPerGroup: 1,
    spaceBetween: 108,
  },
  1025: {
    slidesPerView: slidesPerView.desktop,
    slidesPerGroup: 1,
    spaceBetween: 108,
  },
})

const pushOverrides = (slidesPerView) => ({
  loop: false,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  spaceBetween: 30,
  breakpoints: pushBreakpoints(slidesPerView),
})

export const renderSliderPushMagazine = (slider) => {
  renderMagazineSwiper(slider, {
    containerSelector: '.slider-push-magazine-container',
    theme: 'black',
    skipNavigation: true,
    mobileMax: 1,
    desktopMax: 4,
    overrides: pushOverrides({ tablet: 3, desktop: 4 }),
  })

  renderMagazineSwiper(slider, {
    containerSelector: '.slider-push-magazine-container-3col',
    theme: 'black',
    skipNavigation: true,
    mobileMax: 1,
    desktopMax: 3,
    overrides: pushOverrides({ tablet: 2, desktop: 3 }),
  })
}
